const Footer = () => {

  return (
    <p>Made with ❤️ by <a href="https://www.katherinemorayati.com">Katherine Morayati</a> for <a href="https://www.klayjamesenos.com">Klay-James Enos</a>
	</p>
  );

}

export default Footer;